<template>
  <div
    class="changePhone"
    onselectstart="return false"
    onpaste="return false"
    oncopy="return false;"
    oncut="return false;"
  >
    <p>已完成身份验证</p>
    <b>请输入新的手机号</b>
    <i>手机号</i>
    <div class="tel-code-wrap">
      <div class="tel-wrap">
        <div class="country" @click="countryCodeChange">
          <span class="country-code">+{{ areaCode }}</span>
          <img src="../../assets/images/jt6.png" />
        </div>
        <div class="phoneWrap">
          <input type="tel" maxlength="11" v-model="phone" @keyup="phoneChange" />
          <img
            class="del-btn"
            src="../../assets/images/close.png"
            v-if="phoneFlag"
            @click="clearPhone"
          />
        </div>
      </div>
      <div class="codeWrap">
        <div class="inputWrap">
          <input
            placeholder="图形验证码"
            maxlength="4"
            v-model="imgCodeValue"
            @keyup="imgCodeChange"
          />
          <img
            class="del-btn"
            src="../../assets/images/close.png"
            v-if="imgCodeFlag"
            @click="clearImgCode"
          />
        </div>
        <div class="codeImg" ref="codeImg" @click="getCodeImg">
          <img :src="codeImg" />
        </div>
      </div>
      <div :class="[passFlag ? 'active' : '', 'btn-submit']" @click="getCodeMessage">
        获取验证码
      </div>
    </div>
  </div>
</template>

<script>
import { basepath, random_string } from '../../assets/common/js/config'
export default {
  name: 'codeTest',
  data() {
    return {
      areaCode: '86', // 国际区号
      phone: '', // 手机号
      codeImg: null, // 图片验证码
      timeout: null, // 事件随机码
      imgCodeValue: '', // 图片验证码-值
      phoneFlag: false, // 手机号-删除按钮
      imgCodeFlag: false, // 图片验证码-删除按钮
      passFlag: false // 初步校验
    }
  },
  mounted: function () {
    if (this.$route.query.area_code) {
      this.areaCode = this.$route.query.area_code
    }

    this.getCodeImg()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    imgCodeValue() {
      this.imgCodeChange()
    }
  },
  methods: {
    // 国际区号
    countryCodeChange() {
      this.$router.push({
        path: '/country',
        query: {
          type: 'inphone'
        }
      })
    },
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg =
        basepath +
        'Msg/Captcha/getValidateCode?sessionid=' +
        this.timeout +
        '&width=' +
        width +
        '&height=' +
        height
    },
    // 检测手机号改变
    phoneChange() {
      this.phoneFlag = this.phone ? true : false
      this.checkInfo()
    },
    // 清除手机号
    clearPhone() {
      this.phone = ''
      this.phoneFlag = this.phone ? true : false
      this.checkInfo()
    },
    // 检测图形验证码-值改变
    imgCodeChange() {
      this.imgCodeFlag = this.imgCodeValue ? true : false
      this.checkInfo()
    },
    // 清除图片验证码的值
    clearImgCode() {
      this.imgCodeValue = ''
      this.imgCodeFlag = false
      this.checkInfo()
    },
    // 检测手机号、图形验证码长度
    checkInfo: function () {
      this.passFlag = this.phone.length == 11 && this.imgCodeValue.length == 4 ? true : false
    },
    checkPhone: function () {
      if (!/^1[3456789]\d{9}$/.test(this.value)) {
        return false
      } else {
        if (!this.checked) {
          return false
        } else {
          return true
        }
      }
    },
    getCodeMessage() {
      // 校验长度
      if (!this.passFlag) {
        return
      }

      // 校验手机号格式
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        return
      }

      let that, url

      that = this
      url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.phone +
        '&code=' +
        this.imgCodeValue +
        '&sessionid=' +
        this.timeout +
        '&type=2&area_code=' +
        this.areaCode

      that.$toast.loading({
        mask: true,
        message: '加载中...',
        duration: 0
      })
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          sessionStorage.setItem('ckys4_new_mobile', that.phone)
          sessionStorage.setItem('ckys4_new_area_code', that.areaCode)
          that.$router.replace({
            path: '/phonecode',
            query: {
              area: that.area_code
            }
          })
        } else if (res.data.code == '10011') {
          that.clearImgCode()
          that.getCodeImg()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.changePhone {
  background: #fff;
  padding: 0.38rem 0.3rem 0;
  p {
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
  }
  b {
    display: block;
    margin-bottom: 0.55rem;
    font-size: 29px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 41px;
  }
  i {
    font-size: 0.12rem;
    color: #333333;
    font-style: normal;
    display: block;
    margin-top: 0.19rem;
  }
  .tel-code-wrap {
    font-size: 0.16rem;
    .del-btn {
      width: 0.13rem;
      height: 0.13rem;
      position: absolute;
      top: 0;
      right: 0;
      margin: 0.15rem 0.09rem;
    }
    .tel-wrap {
      position: relative;
      display: flex;
      align-items: center;
      height: 0.44rem;
      line-height: 0.44rem;
      font-size: 0.16rem;
      border-radius: 0.22rem;
      .country {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #5f6274;
        margin-right: 0.15rem;
        img {
          width: 0.16rem;
          height: 0.16rem;
          padding: 0.06rem 0.05rem 0.06rem 0.03rem;
        }
      }
      .phoneWrap {
        width: 100%;
        border-bottom: 1px solid #5f6274;
        input {
          background: none;
          outline: none;
          border: none;
        }
      }
    }
    .codeWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.15rem;
      .inputWrap {
        flex: 1 1 0%;
        position: relative;
        border-radius: 0.22rem;
        padding-left: 0.15rem;
        height: 0.44rem;
        line-height: 0.44rem;
        background: #f7f7f7;
        font-size: 0.16rem;
        color: #000;
        input {
          background: none;
          outline: none;
          border: none;
        }
      }
      .codeImg {
        height: 0.36rem;
        width: 34.5%;
        background: rgb(238, 238, 238);
        margin-left: 0.1rem;
        overflow: hidden;
      }
    }
    .btn-submit {
      margin-top: 0.27rem;
      margin-bottom: 0.17rem;
      width: 100%;
      text-align: center;
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      border-radius: 0.25rem;
      opacity: 0.39;
      font-size: 0.17rem;
      font-weight: 400;
      color: #fff;
      line-height: 0.24rem;
      padding: 0.1rem 0;
      &.active {
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/phone/inputPhone.vue